import {useState} from "react";
import {Outlet} from "react-router-dom";

import {SidebarPanelDrawer} from "base/component/presentational";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import {NO_CONTENT_HEIGHT} from "base/config/measurements";

const PageLayout = ({
    children = null,
    menu = null,
    context = [],
    subPage = false,
    disablePadding = false,
    externalSidebarState = null, // {isSidebarPanelOpen, setSidebarPanelOpen}
    className = "",
}) => {
    const [internalSidebarPanelOpen, setInternalSidebarPanelOpen] = useState(false);

    // Use external state if provided, otherwise use internal state
    const isSidebarPanelOpen =
        externalSidebarState?.isSidebarPanelOpen ?? internalSidebarPanelOpen;
    const setSidebarPanelOpen =
        externalSidebarState?.setSidebarPanelOpen ?? setInternalSidebarPanelOpen;

    return (
        <Stack className={className} direction="row">
            {menu}
            <Box
                sx={{
                    p: subPage && !disablePadding ? 1 : "unset",
                    width: "100%",
                    minHeight: `calc(100vh - ${NO_CONTENT_HEIGHT}px)`,
                }}
            >
                {children ? children : <Outlet context={[...context]} />}
            </Box>
            {children && (
                <SidebarPanelDrawer isSidebarPanelOpen={isSidebarPanelOpen}>
                    <Outlet
                        context={[...context, setSidebarPanelOpen, isSidebarPanelOpen]}
                    />
                </SidebarPanelDrawer>
            )}
        </Stack>
    );
};

export default PageLayout;
